import { type FC } from 'preact/compat';

import cn from 'clsx';

import { Icon } from '@/shared/ui/icon';

import { ReactComponent as LoaderIcon } from '@/assets/images/icons/loader.svg?react';

import { type ButtonProps, ButtonSize, ButtonVariant } from '../types';

import s from './index.module.scss';

export const Button: FC<ButtonProps> = ({
  className,

  icon,
  size = ButtonSize.l50,
  variant = ButtonVariant.primary,

  counter,

  media,
  disabled,
  shine,
  loading,

  children,

  ...buttonProps
}) => {
  return (
    <button
      className={cn(
        s.container,
        s[size],
        s[variant],
        media && s.media,
        shine && s.shine,
        loading && s.loading,
        disabled && s.disabled,
        className
      )}
      disabled={disabled || loading}
      {...buttonProps}
    >
      {!loading && variant === ButtonVariant.volumeButton && (
        <div className={s['loading-button-background-gradient']} />
      )}
      <div className={s.content}>
        {!!icon && <Icon className={s.icon} icon={icon} />}
        {!!children && <span className={s.children}>{children}</span>}
        {counter !== undefined && counter !== null && counter !== '' && (
          <span className={s.counter}>{counter}</span>
        )}
      </div>
      {loading && (
        <div className={s.spinner}>
          <LoaderIcon className={cn(s['spinner-icon'], s[variant])} />
          {ButtonVariant.volumeButton && (
            <LoaderIcon className={cn(s['spinner-icon-double'], s[variant])} />
          )}
        </div>
      )}
    </button>
  );
};
